import { render } from "./facebookIcon.vue?vue&type=template&id=0c28a031"
import script from "./facebookIcon.vue?vue&type=script&lang=js"
export * from "./facebookIcon.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src719114813/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__